import React, { Component } from 'react';
import '../assets/styles/Header.sass';
import underConstructionIcon from'../assets/img/under-construction.png';

class Header extends Component {
  toggleAbout() {
    this.props.onAboutClick();
  }

  render() {
    return(
      <header className="Header">
        <p className="Header__logo">Convert it All</p>

        <img className="Header__under-construction"
             src={underConstructionIcon} alt="Under Construction" />

        <ul className="Header__menu">
          <li className="Header__menu-item">
            <button className="Header__menu-btn Header__menu-btn-border"
                    onClick={this.toggleAbout.bind(this)}>About</button>
          </li>

          <li className="Header__menu-item">
            <button className="Header__menu-btn">Show Table</button>
          </li>
        </ul>
      </header>
    );
  }
}

export default Header;
